import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Pipe({
    name: 'sanitizeHtml',
    standalone: false
})

export class BypassSecurityTrustHtmlPipe implements PipeTransform {
    constructor(
        private sanitizer: DomSanitizer
    ) { }

    transform(html): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
